/**
   WebSocket 协议处理器 
 */
import HUYA from './taf/TafProtocol';
import Taf from './taf/libwup';
import G from './Global';
import ConstEnum from './ConstEnum';
import utils from './utils/Utils';
import TafMx from './taf/tafMapping';
import logger from './utils/Logger.js';
import SignalEvent from './utils/SignalEvent.js';
import store from './utils/store';
import Retry from './utils/Retry';
import SignalCache from './utils/SignalCache';
import EventEmitter from 'events';

class TafHandler extends EventEmitter{
    /**
     *  
     * @param {Object} config 配置参数
     * {
     *    DEFAULT_IP：      
     * }
     */
    constructor(config = {},main) {
        super();
        this.main = main;
        this.report = main.report;
        this.DEBUG_IP = config.DEBUG_IP || 'testws.va.huya.com:80';
        this.DEFAULT_IP = config.DEFAULT_IP || 'ws.api.huya.com';
        this.CDN_IP = config.CDN_IP || 'cdnws.api.huya.com';

        this.WSS_DEBUG_IP = config.WSS_DEBUG_IP || 'testws.va.huya.com:443';
        this.WSS_DEFAULT_IP = config.WSS_DEFAULT_IP || 'wsapi.huya.com';
        this.WSS_CDN_IP = config.WSS_CDN_IP || 'cdnws.api.huya.com';

        this.HTTP_IP = config.HTTP_IP || 'cdnws.api.huya.com';
        this.HTTP_DEBUG_IP = config.HTTP_DEBUG_IP || 'testws.va.huya.com';

        this.STORE_DNS = this.WSS_CDN_IP; //国内用WSS_CDN_IP ，国外用 WSS_DEFAULT_IP
        this.config = config;
        this.config.uid = config.uid || 0;
        this.guid = config.guid || '';
        this.config.appSrc = config.appSrc || '';

        this.connected = false; //是否已连接
        this.ws = null;
        this.url = '';
        this.wsType = config.wsType || 0; //0默认，1 local，2 http，3 test，4 debug
        this.listeners = {};
        this.lockType = null;
        this.delayRemove = {};
        this._pingTimer = 0;
        this.isDoLaunch = false;
        this.isHttps = location.protocol.indexOf("https") > -1;
        this.baseinfo = '?baseinfo=default';
        this.wsBaseInfo = '?baseinfo=default';
        this.extTafFunNameList = []; //小程序接口列表
        this.wsProtocol = (!config.isDebug || this.isHttps) ? 'wss://' : 'ws://';
        this.connectType = config.connectType || 0;  //0 普通  1,云游戏
        this.wsConnectTime = 0;//当前websocket的连接时间
        
        this.reConnectTimes = 0;//重试次数
        this.reconnectDecay = 1.5;  //重连基数
        this.maxReconnectInterval = 30000; //最大重连时间
        this.reconnectInterval = 1000;   //重连时间
        this.reconnectTimeId = 0 ;  //延迟timeid
        this.reconnectMax = 120; //最大重连次数
        this.cloudGameIpList = [];
        this.signalCache = new SignalCache();
        this.wsurl = '';
        this.wsIps = [];
        this.httpWs = [];

        this.serialConnect = config.serialConnect || 0; //是否串行连接
        this.serialTimeOut = 2000; //串行一次连接的超时时间戳
        
        logger.log("config", config);
        logger.log("G", G);

        this.ua = config.ua || '';
        // 将 ua 写入 cookie
        store.setCookie('huya_ua',  this.ua, 365);

        this.creatUserId();
        this.wsBaseInfo = this.setBaseinfo(false,'');
        this.retry = new Retry(config,this.report);
        if(this.connectType == 1) return;//云游戏不做处理


        //国外域名链接
        if (config.isForeign) {
            this.WSS_DEBUG_IP = config.WSS_DEBUG_IP || 'testws.master.live:443';
            this.WSS_DEFAULT_IP = config.WSS_DEFAULT_IP || 'wsapi.nimo.tv';
            this.WSS_CDN_IP = config.WSS_CDN_IP || 'wsapi-global.nimo.tv';
            this.HTTP_IP = config.HTTP_IP || 'wsapi.nimo.tv';
            this.HTTP_DEBUG_IP = config.HTTP_DEBUG_IP || 'testws.master.live';
            this.STORE_DNS = this.WSS_DEFAULT_IP;
        }
          
        this.on("1025305", (data) => {
            this.onWSRedirect(data);
        });
    }

    creatUserId(){
        this.userId = new HUYA.UserId();
        this.userId.lUid = this.config.uid;
        this.userId.sGuid = this.guid;
        this.userId.sToken = "";
        this.userId.sHuYaUA = this.ua;
        this.userId.sCookie = document.cookie;
        this.userId.sDeviceInfo = this.config.device || "";
    }

    start() {
        this.wsConnectTime = Date.now();
        try {
            this._testws = localStorage._testws;
        } catch (error) {
            
        }
        if (this._testws && this._testws != '') {
            this.connecting();
        } else if (this.config.isDebug) {
            this.connecting();
        } else {
            this.testWsIp();
        }

        //超时连cdn
        setTimeout(function () {
            this.wsIps.unshift(!this.config.isDebug ? this.WSS_CDN_IP : this.CDN_IP);
            this.connecting();
        }.bind(this), 5000);
    }

    //并行测试最佳ws连接ip
    async testWsIp(ipList) {
        let wsIps;
        try {
            if(ipList && ipList.length > 0){
                wsIps = ipList;
            }else if (!this.config.isDebug) {
                wsIps = utils.getDns(this.connectType);
                delete localStorage.wssdns;
            } else {
                wsIps = utils.getIps(this.connectType);
                delete localStorage.wssips;
            }
        } catch (error) {
            
        }
        wsIps = wsIps || [];
        let len = wsIps.length;
        if (len == 0) this.connecting();
        let isConnecting = false;
        let badIps = [];
        logger.log("连接列表",wsIps)
        let _onopen = function (e) {
            let _ws_ = e.currentTarget;
            let ip = _ws_.ip;
            _ws_.onopen = _ws_.onclose = _ws_.onerror = undefined;
            if (!isConnecting) {
                isConnecting = true;
                this.url = this.wsProtocol + ip;
                this.connecting(_ws_);
                this.onopen();
                logger.log("连上了",_ws_)
            } else {
                logger.log("已经连上了关闭",_ws_)
                this.wsIps.push(ip);
                _ws_.close(); //[ERROR] Data frame received after close ???
            }
        };
        let _onclose = function (e) {
            let ip = e.currentTarget.ip;
            logger.log("关闭",ip,e)
            if (badIps.indexOf(ip) == -1) {
                badIps.push(ip);
            }

            
            //所有都连不上，连默认的，云游戏不做处理
            if (badIps.length == len && !isConnecting && this.connectType!=1) {
                this.connecting();
            }
        };
        for (let i = 0; i < len; i++) {
            let ip = wsIps[i];
            var dm = this.wsProtocol + ip + this.wsBaseInfo;
            let ws = new WebSocket(dm);
            ws.ip = ip;
            logger.log("开始连接",ip)
            if(this.serialConnect){
                //串行处理
                try {
                    await this.connectWebSocket(ws,_onopen.bind(this),_onclose.bind(this));
                    break;
                } catch (error) {
                    logger.log("WebSocket连接失败", error);
                    continue; // 继续下一次迭代
                }
            }else{
                ws.onopen = _onopen.bind(this);
                ws.onclose = _onclose.bind(this);
                ws.onerror = _onclose.bind(this);
            }
        }
    }
    
    connectWebSocket(ws,onOpen,onClose) {
        return new Promise((resolve, reject) => {
          let connectionTimeout = setTimeout(() => {
            ws.close();
            reject('连接超时');
          }, this.serialTimeOut);
          
          ws.onopen = e => {
            clearTimeout(connectionTimeout);
            onOpen(e);
            resolve();
          };
          let hasClosed = false;
          function closeWs(e){
             if (!hasClosed) {
                hasClosed = true;
                onClose(e);
             }
          }
          ws.onerror = e => {
            clearTimeout(connectionTimeout);
            closeWs(e);
            logger.log("ws.onerror", e);
            reject('连接错误');
          };
      
          ws.onclose = e => {
            clearTimeout(connectionTimeout);
            closeWs(e);
            logger.log("ws.onclose", e);
            reject('连接关闭');
          };
        });
    }
      


    connecting(_ws_) {
        if (this.connected) return;
        logger.log("connecting");
        if (this.ws) {
            this.releaseWs(this.ws);
            let _ip = this.url.replace(this.wsProtocol, '');
            if (this.wsType == 1) this.wsIps.push(_ip);
            else if (this.wsType == 2) this.httpWs.push(_ip);
        }

        if (_ws_) { //_ws_是testWsIp中连接成功的ws
            this.ws = _ws_;
            this.wsType = 1;
        } else {
            let ip = '';
            let _testws = '';
            try {
                 _testws = localStorage._testws;
            } catch (error) {
                
            }
            if (_testws && _testws != '') {
                this.wsType = 3;
                ip = _testws;
            } else {
                this.wsType = 0;
                ip = !this.config.isDebug ? this.WSS_DEFAULT_IP : this.DEFAULT_IP;
                this.report.setCommonDim('iptype', 2);
                if (this.config.isDebug) {
                    this.wsType = 4;
                    ip = this.isHttps ? this.WSS_DEBUG_IP : this.DEBUG_IP;
                    this.report.setCommonDim('iptype', 1);
                } else if (this.wsIps.length > 0) {
                    this.wsType = 1;
                    ip = this.wsIps.shift();
                    if (this.WSS_CDN_IP == ip) {
                        this.report.setCommonDim('iptype', 5);
                    } else {
                        this.report.setCommonDim('iptype', 4);
                    }
                } else if (this.httpWs.length > 0) {
                    this.wsType = 2;
                    ip = this.httpWs.shift();
                }
            }
            this.url = this.wsProtocol + ip;
            logger.log("WebSocket,connet", this.url + this.wsBaseInfo);
            this.ws = new WebSocket(this.url + this.wsBaseInfo);
        }
        this.ws.onopen = this.onopen.bind(this);
        this.ws.onclose = this.onclose.bind(this);
        this.ws.onerror = this.onerror.bind(this);
        this.ws.onmessage = this.onmessage.bind(this);

    }

    releaseWs(ws) {
        if (!ws) return;
        logger.log('===== releaseWs =====', ws);
        clearInterval(this._pingTimer);
        this._pingTimer = 0;
        ws.onopen = ws.onclose = ws.onerror = ws.onmessage = undefined;
        try {
            ws.close();
        } catch (e) {}
    }


    doLaunch() {
        if (this.isDoLaunch) return;
        this.isDoLaunch = true;
        let req = new HUYA.WSLaunchReq();
        req.lUid = this.config.uid;
        req.sGuid = this.guid;
        req.sUA = this.ua;
        req.sAppSrc = this.config.appSrc;
        this.sendWup("launch", "wsLaunch", req, this.onDoLaunch.bind(this));
    }
    // sGuid
    onDoLaunch(data) {
        // WSLaunchRsp
        if (this.guid != data.sGuid) {
            this.guid = data.sGuid;
            this.userId.sGuid = this.guid;
            this.sendWSUpdateUserInfoReq("", data.sGuid);
        }
        let domain = this.config.domain || '';
        store.setCookie('guid', data.sGuid, 365, domain, '/');
        this.queryHttpDns();
        this.emit(SignalEvent.WEBSOCKET_DOLAUNCH,{'guid':this.guid});
    }

    queryHttpDns() {
        let req = new HUYA.QueryHttpDnsReq();
        req.lUid = this.config.uid;
        req.sUA = this.ua;
        req.sAppSrc = this.config.appSrc;
        req.iIpType = 1;
        let vDomain = [this.STORE_DNS];
        req.vDomain.value.push(...vDomain);
        this.sendWupHttp("launch", "queryHttpDns", req, -1, (data)=>{
            this.onGueryHttpDns(data);
        });
    }


    onGueryHttpDns(data) {
        //QueryHttpDnsRsp
        if (this.config.isDebug) return; //测试环境不保存域名
        for (let key in data.mDomain2Ip.value) {
            if (key == this.STORE_DNS) {
                let proxy = data.mDomain2Ip.value[key];
                let ips = proxy.vIp.value;
                utils.storeDns(ips,this.connectType);
                break;
            }
        }
    }
    //============================================================

    send(buffer) {
        if (this.ws && this.connected) {
            this.ws.send(buffer);
        }
    }

    onopen() {
        //websocket打开的时候，重新设置登录标志
        this.wsurl = this.url.replace(this.wsProtocol, '');
        if (!this.connected && this.reConnectTimes == 0) {
            this.wsConnectTime = Date.now() - this.wsConnectTime;
        }
        logger.log("onopen", this.wsurl);
        this.connected = true;
        this.emit(SignalEvent.WEBSOCKET_CONNECTED,{type:this.connectType});
        this.emit(SignalEvent.WS_CONNET_STATE, {
            connected: this.connected,
            type: "open",
            connectType:this.connectType
        });
        clearInterval(this._pingTimer);
        this._pingTimer = setInterval(()=>{
            this.sendHeartBeat();
        }, 60000);

        this.reConnectTimes = 0;
        clearTimeout(this.reconnectTimeId);

        //云游戏直接拿dns，不做验证
        if(this.connectType == 1) return;   
        this.doLaunch();
        var verifyToken = this.config.verifyToken;
        if(verifyToken){
            //走延迟token的逻辑
            this.sendVerifyToken(verifyToken);
        }else{
            this.sendVerifyCookie();
        }
    }

    onclose(evt) {
        this.connected = false;
        this.isDoLaunch = false;
        this.emit(SignalEvent.WS_CONNET_STATE, {
            connected: this.connected,
            type: "close",
            code: evt.code,
            reason: evt.reason,
            connectType:this.connectType
        });


        this.reConnectTimes++;
        if(this.reConnectTimes > this.reconnectMax){
            logger.log('%c=== WebSocket重连次数超标 ===', "font-size:120%");
            return;
        }
        
        //云游戏重连基数调小
        if(this.connectType == 1){
            this.reconnectDecay = 0.1;
        }

        let timeout = this.reconnectInterval * Math.pow(this.reconnectDecay, this.reConnectTimes);
        clearTimeout(this.reconnectTimeId);
        this.reconnectTimeId = setTimeout(()=>{
            this.reconnect(true);
            logger.log('%c=== WebSocket 重连' + this.reConnectTimes + '===' +this.wsurl, "font-size:120%");
        }, timeout > this.maxReconnectInterval ? this.maxReconnectInterval : timeout);
    }


    reconnetWS() {
        this.reConnectTimes = 0;
        this.isDoLaunch = false;
        this.connecting();
    }

    onerror(evt) {
        this.connected  = false;
        this.emit(SignalEvent.WS_CONNET_STATE, {
            connected: this.connected,
            type: "error",
            connectType:this.connectType
        });
        logger.log("%c=== WebSocket Error ===", "font-size:120%", evt);
    }

    sendHeartBeat() {
        let req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_HeartBeatReq;
        let os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.send(os.getBuffer());
    }

    onmessage(evt) {
        // Blob -> ArrayBuffer
        var rspTime = utils.getTime();
        var fileReader = new FileReader();
        fileReader.onload = () => {
            this.decodeTaf(fileReader,rspTime);
        };
        fileReader.readAsArrayBuffer(evt.data);
    }


    decodeTaf(fileReader,rspTime) {
        let arrayBuffer = fileReader.result;
        try {
            if (localStorage.__wup > 1) {
                Taf.Util.jcestream(arrayBuffer, 32);
            }
        } catch (error) {
            
        }
        var decodeResponseBeginTime = utils.getTime();
        let is = new Taf.JceInputStream(arrayBuffer);
        let rsp = new HUYA.WebSocketCommand();
        rsp.readFrom(is);

        switch (rsp.iCmdType) {
            case HUYA.EWebSocketCommandType.EWSCmd_RegisterRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                let registerRsp = new HUYA.WSRegisterRsp();
                registerRsp.readFrom(is);
                this.emit("WSRegisterRsp", registerRsp);
                break;


            case HUYA.EWebSocketCommandType.EWSCmdS2C_RegisterGroupRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                var registerGroup = new HUYA.WSRegisterGroupRsp();
                registerGroup.readFrom(is);
                logger.log("%c<<<<<<< %crspregisterGroup", logger.logcss("#0000E3"), logger.logcss("#D9006C"), registerGroup);
                this.emit(SignalEvent.WS_REGISTER_GROUP_RSP, registerGroup);
                this.retry.del('group');
                break;

            case HUYA.EWebSocketCommandType.EWSCmdS2C_UnRegisterGroupRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                var unRegisterGroup = new HUYA.WSUnRegisterGroupRsp();
                unRegisterGroup.readFrom(is);
                logger.log("%c<<<<<<< %crspunRegisterGroup", logger.logcss("#0000E3"), logger.logcss("#D9006C"), unRegisterGroup);
                this.emit(SignalEvent.WS_UNREGISTER_GROUP_RSP, unRegisterGroup);
                break;

            case HUYA.EWebSocketCommandType.EWSCmd_WupRsp:
                let wup = new Taf.Wup();
                var unipacketDecodeBeginTime = utils.getTime();
                wup.decode(rsp.vData.buffer);
                var unipacketDecodeEndTime = utils.getTime();
                var code = -1;
                var special = false;
                try {
                    code = wup.readInt32('');
                } catch (err) {
                    special = true;
                    logger.log("获取返回值失败", err);
                }
                const {iRequestId,sFuncName,sServantName} = wup;
                this.report.setField(iRequestId, "hysignal_response",rspTime);
                this.report.setDim(iRequestId, "retcode", code);
                if (code < 0) {
                    this.report.setDim(iRequestId, "success", ConstEnum.REPORT_SUCCESS_2);
                } else {
                    this.report.setDim(iRequestId, "success", ConstEnum.REPORT_SUCCESS_0);
                }
                this.report.setField(iRequestId, "decode_response_begin",decodeResponseBeginTime);
                this.report.setField(iRequestId, "unipacket_decode_begin",unipacketDecodeBeginTime);
                this.report.setField(iRequestId, "unipacket_decode_end",unipacketDecodeEndTime);
                this.fireExtTafData(0, sFuncName, rsp.vData.buffer);
                let wupClass = TafMx.WupMapping[sFuncName];
                let cb = this.retry.getCallBack(iRequestId);
                var re = {
                    id: iRequestId,
                    fn: sFuncName,
                    cb
                };
                if (wupClass) {
                    let wupStruct = new wupClass();
                    wupStruct.bcode = code;
                    try {
                        if (code >= 0) {
                            var data = wup.iVersion == 3 ? wup.newdata : wup.data;
                            let key = this.getWupKey(data,special);
                            this.report.setField(iRequestId, "unipacket_read_rsp_end");
                            if(key != 'noKey'){
                                wup.readStruct(key, wupStruct, wupClass);
                            }
                        }
                    } catch (err) {
                        logger.log("ConstEnum.SIGNAL_ERROR_READ_ERROR", err);
                        re.code = ConstEnum.SIGNAL_ERROR_READ_ERROR;
                        this.reportError(re);
                        return;
                    }
                    this.report.setField(iRequestId, "decode_response_end");
                    if (iRequestId > 0) {
                        wupStruct.iRequestId = iRequestId;
                    }
                    logger.log("%c<<<<<<< %crspWup:%c " + sFuncName, logger.logcss("#0000E3"), logger.logcss("black"), logger.logcss("#0000E3"), sServantName, wupStruct);
                    this.report.setField(iRequestId, "join_dispatcher_thread");
                    this.report.setField(iRequestId, "dispatcher_thread_execute_time");
                    wupStruct.sdkcode = 0;
                    this.emit(iRequestId > 0 ? sFuncName + iRequestId : sFuncName, wupStruct);
                } else {
                    //没注册不报了
                    //this.reportError(re);
                    cb && cb({sdkcode:ConstEnum.SIGNAL_ERROR_NO_REGISTER,bcode:code});
                    this.report.clearData(iRequestId);
                    this.retry.del(iRequestId);
                }
                break;

            case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                var pushMess = new HUYA.WSPushMessage();
                pushMess.readFrom(is);
                let uri = pushMess.iUri;
                const lMsgId = pushMess.lMsgId;
                const groupId = pushMess.sGroupId;
                const hasSame = this.signalCache.cache(lMsgId);
                if (lMsgId && hasSame) {
                    logger.log("重复的消息id", lMsgId, groupId);
                    return;
                }
                is = new Taf.JceInputStream(pushMess.sMsg.buffer);
                let uriClass = TafMx.UriMapping[pushMess.iUri];
                if (uriClass) {
                    let uriStruct = new uriClass();
                    uriStruct.readFrom(is);
                    logger.log("%c<<<<<<< %crspMsgPush, %curi=" + uri, logger.logcss("#0000E3"), logger.logcss("black"), logger.logcss("#8600FF"), uriStruct);
                    this.emit(uri, uriStruct);
                } else {
                    logger.log("收到未映射的 WSPushMessage，uri=" + pushMess.iUri);
                }
                this.emit("origin:" + uri, {
                    data: pushMess.sMsg.buffer,
                    groupId,
                    connectType:this.connectType
                });
                this.emit(SignalEvent.WS_URI_NOTICE, {
                    uri,
                    data: pushMess.sMsg.buffer,
                    groupId,
                    connectType:this.connectType
                });
                this.fireExtTafData(uri, "", pushMess.sMsg.buffer)
                break;
            case HUYA.EWebSocketCommandType.EWSCmdS2C_HeartBeatRsp:
                break;
            case HUYA.EWebSocketCommandType.EWSCmdS2C_VerifyCookieRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                let verifyRsp = new HUYA.WSVerifyCookieRsp();
                verifyRsp.readFrom(is);
                let isPass = verifyRsp.iValidate == 0;
                this.emit(SignalEvent.VERIFYCOOKIE_PASS, isPass);
                logger.log('VerifyCookie校验' + (isPass ? '通过！' : '失败！'));
                break;

            case HUYA.EWebSocketCommandType.EWSCmdS2C_VerifyHuyaTokenRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                let verifyTokenRsp = new HUYA.WSVerifyHuyaTokenRsp();
                verifyTokenRsp.readFrom(is);
                let isPass2 = verifyTokenRsp.iValidate == 0;
                this.emit(SignalEvent.VERIFYTOKEN_PASS, isPass2);
                logger.log('verifyToken校验' + (isPass2 ? '通过！' : '失败！'));
                break;

            case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq_V2:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                var pushMess = new HUYA.WSPushMessage_V2();
                pushMess.readFrom(is);
                for (var i = 0, len = pushMess.vMsgItem.value.length; i < len; i++) {
                    let data = pushMess.vMsgItem.value[i];
                    let uri = data.iUri;
                    let lMsgId = data.lMsgId;
                    let uriClass = TafMx.UriMapping[uri];
                    const groupId = pushMess.sGroupId;
                    const hasSame = this.signalCache.cache(lMsgId);
                    if (lMsgId && hasSame) {
                        logger.log("重复的消息id", lMsgId, groupId);
                        continue;
                    }
                    this.emit("origin:" + uri, {
                        data: data.sMsg.buffer,
                        groupId,
                        connectType:this.connectType
                    });
                    this.emit(SignalEvent.WS_URI_NOTICE, {
                        uri,
                        data: data.sMsg.buffer,
                        groupId,
                        connectType:this.connectType
                    });
                    this.fireExtTafData(uri, "", data.sMsg.buffer);
                    if (uriClass) {
                        let uriStruct = new uriClass();
                        let is = new Taf.JceInputStream(data.sMsg);
                        uriStruct.readFrom(is);
                        logger.log("%c<<<<<<< %crspMsgPushV2, %curi=" + uri, logger.logcss("#0000E3"), logger.logcss("black"), logger.logcss("#8600FF"), uriStruct);
                        this.emit(uri, uriStruct);
                    } else {
                        logger.log("收到未映射的 WSPushMessage_V2 uri=" + uri);
                    }
                }
                break;

            //云游戏回包
            case HUYA.EWebSocketCommandType.EWSCmdS2C_CloudGamePush:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                let cloudGamePacket = new HUYA.CloudGamePacket();
                cloudGamePacket.readFrom(is);
                const {sRequestId} = cloudGamePacket;
                this.emit(SignalEvent.CLOUD_GAME_DATA,cloudGamePacket);
                logger.log("%c<<<<<<< %ccloundGameData:", logger.logcss("#0000E3"), logger.logcss("black"), cloudGamePacket);
                break;

            case HUYA.EWebSocketCommandType.EWSCmdS2C_UpdateUserExpsRsp:
                is = new Taf.JceInputStream(rsp.vData.buffer);
                let wSUpdateUserExpsRsp = new HUYA.WSUpdateUserExpsRsp();
                wSUpdateUserExpsRsp.readFrom(is);
                this.emit(SignalEvent.WS_UPDATE_USER_EXPS_RSP,wSUpdateUserExpsRsp);
                logger.log("WSUpdateUserExpsRsp",wSUpdateUserExpsRsp);
                break;

            default:
                logger.log("%c<<<<<<< Not matched CmdType: " + rsp.iCmdType);
        }
    }

    getWupKey(data,special) {     
        //special 特殊的返回值是包结构，要特殊处理   
        if(data.get('tRsp')){
            return 'tRsp'
        }

        if(special && data.get('')){
            return ''
        }
        return 'noKey';
      }

    //服务器下线重连websocket
    onWSRedirect(data) {
        //WSRedirect
        let vRemoveIps = data.vRemoveIps.value;
        logger.log("---onWSRedirect---");
        logger.log("vRemoveIps", vRemoveIps);
        logger.log("this.wsurl", this.wsurl);
        for (let i = 0; i < this.wsIps.length; i++) {
            for (let j = 0; j < vRemoveIps.length; j++) {
                if (this.wsIps[i] == vRemoveIps[j]) {
                    this.wsIps.splice(i, 1);
                }
                if (this.wsurl == vRemoveIps[j]) {
                    this.reconnect();
                }
            }
        }
        logger.log("storeDns", this.wsIps);
        utils.storeDns(this.wsIps,this.connectType);
    }

    //断开重连接
    reconnect(noResetTime) {
        if(!noResetTime){
            this.reConnectTimes = 0;
        }
        this.releaseWs(this.ws);
        this.ws = null;
        this.connected = false;
        this.isDoLaunch = false;
        if(this.connectType == 1){
            //云游戏重连，用旧的
            this.connectIPList(this.cloudGameIpList);
        }else {
            this.connecting();
        }
    }


    //============================================================

    //wup请求
    _sendWup(servantName, funcName, data, iRequestId, callback,extData) {
        logger.log("%c>>>>>>> %creqWup: %c" + funcName, logger.logcss("#009100"), logger.logcss("black"), logger.logcss("#009100"), servantName, data);
        this.report.setDim(iRequestId, "path", "/" + servantName + "/" + funcName);
        this.report.setDim(iRequestId, "channel", 'ws');
        this.report.setDim(iRequestId, "ip", this.wsurl);
        this.report.setField(iRequestId, "unipacket_encode_begin");
        var re = {
            id: iRequestId,
            fn: funcName,
            cb: callback
        };
        try {
            let wup = new Taf.Wup();
            if(extData){
                const {wupTimeout,wupContext} = extData;
                wupTimeout && wup.setTimeOut(wupTimeout);
                wupContext && Object.assign(wup.context.value, wupContext);
            }
     
            wup.setServant(servantName);
            wup.setFunc(funcName);
            wup.setRequestId(iRequestId);
            wup.writeStruct("tReq", data);
            let req = new HUYA.WebSocketCommand();
            req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_WupReq;
            req.vData = wup.encode();
            let traceid = this.report.getTraceId(iRequestId);
            if (traceid) {
                const parentSpanId = 0; //父spanid
                const traceIdValue = `${traceid}:${traceid}:${parentSpanId}:${G.enableTrace}`
                req.traceId = traceIdValue;
            }
            var os = new Taf.JceOutputStream();
            req.writeTo(os);
            this.report.setField(iRequestId, "unipacket_encode_end");
        } catch (err) {
            logger.log(err);
            re.code = ConstEnum.SIGNAL_ERROR_WRITE_ERROR;
            this.reportError(re);
            return;
        }
        try {
            this.send(os.getBuffer());
        } catch (err) {
            logger.log(err);
            re.code = ConstEnum.SIGNAL_ERROR_WS_SEND_ERROR;
            this.reportError(re);
            return;
        }
        this.report.setField(iRequestId, "hysignal_enqueue");
    }

    sendWup(servantName, funcName, data, callback = null, iRequestId = -1, tryCount = 1,extData={}) {
        const startTime = +new Date();
        if (typeof callback === "function") {
            let wupCallback = (backData) => {
                this.report.setField(iRequestId, "execute_end");
                callback && callback(backData);
                this.sendReport(iRequestId);
                this.report.clearData(iRequestId);
                this.retry.del(iRequestId);
                this.reportAPI && this.reportAPI({type:'reportApiTime',state:"end",servantName,funcName,startTime,endTime:+new Date()});
            };
            this.once(iRequestId > 0 ? `${funcName}${iRequestId}` : funcName, wupCallback);
        }
        let retryData = {
            id: iRequestId,
            reSend:  (servantName, funcName, data, iRequestId, callback,extData) => {
                this._sendWup(servantName, funcName, data, iRequestId, callback,extData);
            },
            servantName,
            funcName,
            data,
            tryCountMax: tryCount,
            errFun: info => {
                let re = {
                    id:info.id,
                    fn:info.funcName,
                    code: ConstEnum.SIGNAL_ERROR_LOCAL_TIMEOUT,
                    cb:info.callbackFun
                };
                this.reportError(re);
            },
            callbackFun: callback
        };
   
        this.retry.add(retryData);
        this._sendWup(servantName, funcName, data, iRequestId, callback,extData);
        this.reportAPI && this.reportAPI({type:'reportApiTime',state:"start",servantName,funcName,startTime});
    };



    sendRegisterGroup(groupList, sToken) { //WSRegisterGroupReq
        this._sendRegisterGroup(groupList, sToken);
        let retryData = {
            id: 'group',
            reSend: (groupList, sToken = '') => {
                this._sendRegisterGroup(groupList, sToken);
            },
            servantName: 'group',
            funcName: 'group',
            data: null,
            tryCountMax: 2,
            errFun: this.sendRegisterGroupErr,
            callbackFun: null,
            paramlist: [groupList]
        };
        this.retry.add(retryData);
    }

    _sendRegisterGroup(groupList, sToken) {
        let group = new HUYA.WSRegisterGroupReq();
        group.vGroupId.value.push(...groupList);
        group.sToken = sToken || '';
        logger.log("%c>>>>>>> %creqRegisterGroup:", logger.logcss("#009100"), logger.logcss("#D26900"), group);

        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_RegisterGroupReq;
        this.sendWebSocketCommand(group,cmdType);
    }

    sendRegisterGroupErr() {
        logger.log("进组重试超过次数");
    }

    sendUnRegisterGroup(groupList) { //WSUnRegisterGroupReq
        let group = new HUYA.WSUnRegisterGroupReq();
        group.vGroupId.value.push(...groupList);
        logger.log("%c>>>>>>> %creqUnRegisterGroup:", logger.logcss("#009100"), logger.logcss("#D26900"), group);

        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_UnRegisterGroupReq;
        this.sendWebSocketCommand(group,cmdType);
        this.retry.del('group');
    }


    sendWSUpdateUserInfoReq(appSrc, guid) {
        logger.log(">>>>>>>  sendWSUpdateUserInfoReq:", appSrc, guid);
        let wsreq = new HUYA.WSUpdateUserInfoReq();
        wsreq.sAppSrc = appSrc ? appSrc : this.config.appSrc;
        wsreq.sGuid = guid ? guid : this.guid;

        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_UpdateUserInfoReq;
        this.sendWebSocketCommand(wsreq,cmdType);
    }


    sendVerifyCookie() {
        if (this.config.uid <= 0) return;//未登录不授信
        let data = new HUYA.WSVerifyCookieReq();
        data.lUid = this.config.uid;
        data.sGuid = this.guid;
        data.sUA = this.ua;
        data.bAutoRegisterUid = 1;
        data.sAppSrc = this.config.appSrc;
        data.sCookie = document.cookie;

        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_VerifyCookieReq;
        this.sendWebSocketCommand(data,cmdType);
        logger.log("VerifyCookie:", data);
    }


    sendVerifyToken(verifyToken) {
        const {type,token} = verifyToken;
        let data = new HUYA.WSVerifyHuyaTokenReq();
        data.tId.lUid = this.config.uid;
        data.tId.sGuid = this.guid;
        data.tId.sToken = token;
        data.tId.iTokenType = type;
        data.tId.sHuYaUA = this.ua;
        data.tId.sCookie = document.cookie;
        data.tId.sDeviceInfo = this.config.device || "";
        data.bAutoRegisterUid = 1;
        data.sAppSrc = this.config.appSrc;

        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_VerifyHuyaTokenReq;
        this.sendWebSocketCommand(data,cmdType);
        logger.log("sendVerifyToken:", data);
    }

    sendReport(requestId) {
        if (requestId === -1) return; //sdk内部发送的过滤
        if (G.enableTrace <= 0) return;
        var re = new HUYA.MetricDetailSet();
        let userid = new HUYA.UserId();
        utils.copy(userid,this.userId);
        //上报使用appid对应的ua
        userid.sHuYaUA = this.config.APPID.toLowerCase() + "&" + G.ver + "&signalsdk";;
        re.tId = userid;
        re.vMetricDetail.value.push(this.createDetailById(requestId));
        logger.log('sendReport', re);
        this.sendReportHttp('metric', 'reportDetailV2', re);
    }


    createDetailById(requestId) {
        let detail = new HUYA.MetricDetail();
        detail.sMetricName = 'hymtp.hyns.monitor.client';
        detail.iTS = Date.now();
        var vField = this.report.getFieldData(requestId);
        var vDim = this.report.getDimData(requestId);
        this.fillField(vField, detail.vFiled.value);
        this.fillDimension(vDim, detail.vDimension.value);
        return detail;
    }

    fillField(vField, list) {
        if (vField) {
            for (let sName in vField) {
                let field = new HUYA.Field();
                field.sName = sName;
                field.fValue = vField[sName];
                list.push(field);
            }
        }
    }

    fillDimension(vDim, list) {
        for (let key in vDim) {
            let dimension = new HUYA.Dimension();
            dimension.sName = key;
            dimension.sValue = vDim[key];
            list.push(dimension);
        }
    }

    sendDataMetric(dataList,ua) {
        let re = new HUYA.MetricDetailSet();
        let userid = new HUYA.UserId();
        utils.copy(userid,this.userId);
        if(ua){
            userid.sHuYaUA = ua;
        }
        re.tId = userid;
        let time = Date.now();
        for (let i in dataList) {
            re.vMetricDetail.value.push(this.createDetail(dataList[i], time));
        }
        logger.log('sendDataMetric', re);
        this.sendReportHttp('metric', 'reportDetailV2', re);
    }

    createDetail(data, time) {
        let detail = new HUYA.MetricDetail();
        detail.sMetricName = data.sMetricName;
        detail.iTS = time;
        this.fillField(data.vField, detail.vFiled.value);
        this.fillDimension(data.vDimension, detail.vDimension.value);
        this.fillExLog(data.vExLog, detail.vExLog.value);
        return detail;
    }

    fillExLog(vExLog, list) {
        this.fillDimension(vExLog, list);
    }

    rspDecode(buffer, className) {
        let wup = new Taf.Wup();
        wup.decode(buffer);
        let wupClass = TafMx.WupMapping[wup.sFuncName];
        if (wupClass) {
            let wupStruct = new wupClass();
            let data = wup.iVersion == 3 ? wup.newdata : wup.data;
            let key = this.getWupKey(data);
            wup.readStruct(key, wupStruct, className);
            return wupStruct;
        } else {
            return null;
        }
    }

    sendReportHttp(servantName, funcName, data) {
        let wup = new Taf.Wup();
        wup.setServant(servantName);
        wup.setFunc(funcName);
        wup.writeStruct('tReq', data);
        let buffer = wup.encode().getBuffer();
        let timestamp = new Date().getTime();
        let url = this.config.reportUrl || 'https://statwup.huya.com';
        Taf.Util.ajax(url + '?timestamp=' + timestamp,
            buffer,
            () =>{
                //logger.log('上报成功', data);
            },
            (res) =>{
                logger.log('上报失败', res);
            }
        );
    }


    //{funcName,buff} 
    sendExtWup(data) {
        const {
            buff,
            funcName
        } = data;
        if (this.extTafFunNameList.indexOf(funcName) == -1) {
            this.extTafFunNameList.push(funcName);
        }
        buff && this.send(buff);
    }

    fireExtTafData(uri, funcName, data) {
        if (uri || (funcName && this.extTafFunNameList.indexOf(funcName) != -1)) {
            this.emit(SignalEvent.EXT_TAF_DATA, {
                uri,
                funcName,
                data
            });
        }
    }

    sendWupHttp(servantName, funcName, data, iRequestId, callback,extData) {
        const startTime = +new Date();
        var re = {
            id: iRequestId,
            fn: funcName,
            cb: callback
        };
        let twup = new Taf.Wup();
        if(extData){
            const {wupTimeout,wupContext} = extData;
            wupTimeout && wup.setTimeOut(wupTimeout);
            wupContext && Object.assign(wup.context.value, wupContext);
        }
        
        this.report.setDim(iRequestId, "path", "/" + servantName + "/" + funcName);
        this.report.setField(iRequestId, "unipacket_encode_begin");
        this.report.setDim(iRequestId, "channel", 'http');
        let httpIp = this.config.isDebug ? this.HTTP_DEBUG_IP : this.HTTP_IP;
        this.report.setDim(iRequestId, "ip", httpIp);
        try {
            twup.setServant(servantName);
            twup.setFunc(funcName);
            twup.setRequestId(iRequestId);
            twup.writeStruct('tReq', data);
            logger.log("%c>>>>>>> %c http reqWup: %c" + funcName, logger.logcss("#009100"), logger.logcss("black"), logger.logcss("#009100"), servantName, data);
            var buffer = twup.encode().getBuffer();
        } catch (err) {
            logger.log("writeStruct错误",err);
            re.code = ConstEnum.SIGNAL_ERROR_WRITE_ERROR;
            this.reportError(re);
            return;
        }
        let timestamp = new Date().getTime();
        let traceId = this.report.getTraceId(iRequestId);
        if (traceId) {
            const parentSpanId = 0; //父spanid
            const traceIdValue = `${traceId}:${traceId}:${parentSpanId}:${G.enableTrace}`
            traceId = traceIdValue;
        }
        this.baseinfo = this.setBaseinfo(true,traceId);
        let url = `https://${httpIp}${this.baseinfo}`;
        this.report.setField(iRequestId, "unipacket_encode_end");
        this.report.setField(iRequestId, "hysignal_enqueue");

        try {
            Taf.Util.ajax(url + '&timestamp=' + timestamp,
                buffer,
                (buffer) => {
                    var wup;
                    var code;
                    var begintTime = utils.getTime();
                    var unipacketDecodeEndTime;
                    try {
                        wup = new Taf.Wup();
                        wup.decode(buffer);
                        unipacketDecodeEndTime = utils.getTime();
                    } catch (err) {
                        logger.log("decodewup错误",err);
                        re.code = ConstEnum.SIGNAL_ERROR_FIRST_PACKAGE;
                        this.reportError(re);
                        return;
                    }
                    var special = false;
                    try {
                        code = wup.readInt32('');
                    } catch (error) {
                        special = true;
                    }
                    const {iRequestId,sFuncName,sServantName} = wup;
                    this.report.setField(iRequestId, "hysignal_response",begintTime);
                    this.report.setDim(iRequestId, "retcode", code);
                    if (code < 0) {
                        this.report.setDim(iRequestId, "success", ConstEnum.REPORT_SUCCESS_2);
                    } else {
                        this.report.setDim(iRequestId, "success", ConstEnum.REPORT_SUCCESS_0);
                    }
                    this.report.setField(iRequestId, "decode_response_begin",begintTime);
                    this.report.setField(iRequestId, "unipacket_decode_begin",begintTime);
                    this.report.setField(iRequestId, "unipacket_decode_end",unipacketDecodeEndTime);
                    let wupClass = TafMx.WupMapping[sFuncName];
                    if (wupClass) {
                        var wupStruct = new wupClass();
                        wupStruct.bcode = code;
                        try {
                            if (code >= 0) {
                                var rdata = wup.iVersion == 3 ? wup.newdata : wup.data;
                                var key = this.getWupKey(rdata,special);
                                this.report.setField(iRequestId, "unipacket_read_rsp_end");
                                if(key != 'noKey'){
                                    wup.readStruct(key, wupStruct, wupClass);
                                }
                            }
                        } catch (err) {
                            logger.log("readStruct错误",err);
                            re.code = ConstEnum.SIGNAL_ERROR_READ_ERROR;
                            this.reportError(re);
                            return;
                        }
                        this.report.setField(iRequestId, "decode_response_end");
                        if (iRequestId > 0) {
                            wupStruct.iRequestId = iRequestId;
                        }

                        logger.log("%c<<<<<<< %chttp rspWup:%c"+ funcName, logger.logcss("#0000E3"), logger.logcss("black"), logger.logcss("#0000E3"), sServantName,wupStruct);
                        this.report.setField(iRequestId, "join_dispatcher_thread");
                        this.report.setField(iRequestId, "dispatcher_thread_execute_time");
                        this.report.setField(iRequestId, "execute_end");
                        this.sendReport(iRequestId);
                        wupStruct.sdkcode = 0;
                        callback && callback(wupStruct);
                        this.reportAPI && this.reportAPI({type:'reportApiTime',state:"end",servantName,funcName,startTime,endTime:+new Date()});
                    } else {
                        callback && callback({sdkcode:ConstEnum.SIGNAL_ERROR_NO_REGISTER,bcode:code});
                        this.report.clearData(iRequestId);
                        this.retry.del(iRequestId);
                        //没注册不报了
                        //this.reportError(re);
                    }
                },
                (status) => {
                    re.code = ConstEnum.SIGNAL_HTTP_REQUEST_ERROR;
                    this.reportError(re,status);
                    logger.log('http请求失败', servantName, funcName, status);
                }
            );
            this.reportAPI && this.reportAPI({type:'reportApiTime',state:"start",servantName,funcName,startTime});
        } catch (err) {
            logger.log("http请求error",err);
            re.code = ConstEnum.SIGNAL_ERROR_WS_SEND_ERROR;
            this.reportError(re);
        }
    }

    reportError(data,bcode) {
        const {
            fn,
            id,
            code
        } = data;
        this.report.setDim(id, "retcode", code);
        this.report.setDim(id, "success", ConstEnum.REPORT_SUCCESS_1);
        this.report.setField(id, "execute_end");
        this.sendReport(id);
        this.report.clearData(id);
        this.retry.del(id);
        var wupClass = TafMx.WupMapping[fn];
        let wupStruct = {};
        if (wupClass) {
            wupStruct = new wupClass();
        }
        wupStruct.bcode = bcode===undefined?0:bcode;
        wupStruct.sdkcode = code;
        if(data.cb){
            data.cb(wupStruct);
            this.removeListener(fn + id, data.cb);
        }
    }

    setBaseinfo(isHttp,traceid) {
        try {
            const baseinfo = this.makeBaseInfo(isHttp,traceid);
            logger.log("baseinfo", baseinfo);
            return baseinfo;
        } catch (error) {
            logger.log("setBaseinfo", error);
            return '?baseinfo=default';
        }
    }


    makeBaseInfo(isHttp,traceid){
        //长连接信令不带cookie,短连接带cookie,traceid
        let info = new HUYA.WSConnectParaInfo();
        info.lUid = this.config.uid;
        info.sGuid = this.guid;
        info.sUA = this.ua;
        info.sAppSrc = this.config.appSrc;
        info.sExp = this.config.exp;
        if(isHttp && this.config.uid > 0){
            info.sCookie = document.cookie;
        }
        if(isHttp && traceid){
            info.sTraceId = traceid;
        }
        
        let customHeaders = this.config.customHeaders;
        if(customHeaders && typeof customHeaders === 'object'){
            utils.copy(info.mCustomHeaders.value,customHeaders);
        }
        const os = new Taf.JceOutputStream();
        info.writeTo(os);
        const buffer = os.getBuffer();
        const buffStr = utils.ab2str(buffer, false);
        const buffstr2 = window.btoa(buffStr);
        return `?baseinfo=${encodeURIComponent(buffstr2)}`;
    }

    //并行连执行的ip列表
    connectIPList(ipList){
        this.cloudGameIpList = ipList;
        let list = [];
        for(let j = 0,len=ipList.length; j < len; j++) {
            let data = ipList[j];
            const {host,ip} = data;
            let ipdns = this.isHttps?`${host}`:`${ip || host}`;
            list.push(ipdns);
        }
        this.testWsIp(list);
    }

    //云游戏发送
    sendCloudGameReq(data) {
        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_CloudGameReq;
        this.sendWebSocketCommand(data,cmdType);
        logger.log("%c>>>>>>> %csendCloudGameReq:", logger.logcss("#009100"), logger.logcss("black"), data);
    }


    sendWebSocketCommand(data,cmdType){
        var os = new Taf.JceOutputStream();
        data.writeTo(os);
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = cmdType;
        req.vData = os.getBinBuffer();
        os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.send(os.getBuffer());
    }

    clear(){
        this.releaseWs(this.ws);
        this.ws = null;
    }

    getCurrentWSUrl(){
        return this.wsurl;
    }

    setReportAPI(reportAPI){
        this.reportAPI = reportAPI;
    }

    sendWupNew(servantName,funcName,data,rsp,tryCount=1,extData={}){
        return new Promise((resolve,reject) =>{
            const startTime = +new Date();
            TafMx.WupMapping[funcName] = rsp;
            let requestId  = G.getRequestId();
            const traceid = G.getTraceId(); 
            this.report.setDim(requestId,"traceid",traceid);
            this.report.setDim(requestId,"spanid",traceid);
            this.report.setField(requestId,"execute");
            let callback = (backData) => {
                const {bcode,sdkcode} = backData;
                if(bcode < 0 || (sdkcode < 0 && sdkcode !== ConstEnum.SIGNAL_ERROR_NO_REGISTER)){
                    reject(backData);
                }else{
                    resolve(backData);
                }
            }
            let wupCallback = (backData) => {
                this.report.setField(requestId, "execute_end");
                this.sendReport(requestId);
                this.report.clearData(requestId);
                this.retry.del(requestId);
                this.reportAPI && this.reportAPI({type:'reportApiTime',state:"end",servantName,funcName,startTime,endTime:+new Date()});
                callback(backData);
            };

            const eventName = `${funcName}${requestId}`;
            this.once(eventName, wupCallback);
            let retryData = {
                id: requestId,
                reSend:  (servantName, funcName, data, requestId, callback,extData) => {
                    this._sendWup(servantName, funcName, data, requestId, callback,extData);
                },
                servantName,
                funcName,
                data,
                tryCountMax: tryCount,
                errFun: info => {
                    let re = {
                        id:info.id,
                        fn:info.funcName,
                        code: ConstEnum.SIGNAL_ERROR_LOCAL_TIMEOUT,
                        cb:info.callbackFun
                    };
                    this.reportError(re);
                },
                callbackFun: callback
            };
            this.retry.add(retryData);
            if(!this.connected){
                this.sendWupHttp(servantName,funcName,data,requestId,callback,extData);
            }else{
                this._sendWup(servantName, funcName, data, requestId, callback,extData);
            }
            this.reportAPI && this.reportAPI({type:'reportApiTime',state:"start",servantName,funcName,startTime});
        });
    }

    updateUserExps(exps){
        let req = new HUYA.WSUpdateUserExpsReq();
        Object.assign(req.mExps.value, exps);
        const cmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_UpdateUserExpsReq;
        this.sendWebSocketCommand(req,cmdType);
        return new Promise((resolve,reject) =>{
            this.once(SignalEvent.WS_UPDATE_USER_EXPS_RSP, (rsp) => {
                const {iResCode} = rsp;
                if(iResCode === 0){
                    resolve(rsp);
                }else{
                    reject(rsp);
                }
            });
        });
    }
}

export default TafHandler;